import dayjs from "dayjs";
import { useEffect, useState } from "react";

const useDateObject = (value, format) => {
  const [dateValue, setDateValue] = useState(null);

  useEffect(() => {
    if (value instanceof Date) return setDateValue(value);

    const isoStringAsDate = dayjs(value, format).toDate();

    if (isoStringAsDate.toString() !== "Invalid Date") {
      setDateValue(isoStringAsDate);
    } else {
      setDateValue(null);
    }
  }, [value, format]);

  return { dateValue, setDateValue };
};

export default useDateObject;
